import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { TextField } from '@/shared/forms/TextField';
import { Button } from '@/shared/ui/Button';

import { useForgotPassword } from '../hooks/usePasswordReset';
import { forgotSchema } from '../validation/reset.schema';

export function ForgotPasswordForm({ onSent }) {
  const forgot = useForgotPassword();
  const form = useForm({
    resolver: zodResolver(forgotSchema),
    defaultValues: { email: '' },
    mode: 'onBlur',
  });

  const onSubmit = form.handleSubmit(async (values) => {
    try {
      await forgot.mutateAsync({ email: values.email });
      onSent(values.email);
    } catch (error) {
      if (error.status === 422 && error.details?.email) {
        form.setError('email', { message: error.details.email[0] });
        return;
      }
      form.setError('root', {
        message:
          error.status === 429
            ? 'Too many attempts. Try again in a minute.'
            : error.message || 'Could not send the code. Please try again.',
      });
    }
  });

  return (
    <form onSubmit={onSubmit} noValidate className="grid gap-5">
      <TextField
        label="Email"
        required
        type="email"
        autoComplete="email"
        placeholder="you@example.com"
        error={form.formState.errors.email?.message}
        {...form.register('email')}
      />
      {form.formState.errors.root && (
        <p
          role="alert"
          className="rounded-lg bg-red-500/10 p-3 text-sm text-red-700 dark:text-red-300"
        >
          {form.formState.errors.root.message}
        </p>
      )}
      <Button type="submit" loading={forgot.isPending} className="w-full">
        Send reset code
      </Button>
    </form>
  );
}
